import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAllFloors, getFloorAssignById, updateFloorAssign } from "adminApi/FloorAssignApi/FloorAssign";
import { FloorAssignRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/FloorAssignField.json";
import useFetchAllData from "Hooks/useFetchAllData";
import EditFloorAssignForm from "./Components/EditFloorAssignForm";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditFloorAssign = () => {
    const navigate = useNavigate();
    const { formdata } = fields;
    const { id } = useParams();

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        FloorAssignRules
    );

    const { data: floorOptions, loading: loadingFloor } = useFetchAllData(getAllFloors);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            // Copy before mutating to avoid modifying original state
            const payload = { ...formValues };
            if (payload.room_no) {
                payload.room_numbers = payload.room_no
                    .split(",")
                    .map((r) => r.trim())
                    .filter(Boolean);
                delete payload.room_no;
            }
            return await updateFloorAssign({ id, data: payload });
        },
        (vals) => {
            // Copy before mutating
            const v = { ...vals };
            delete v.button;
            const err = validateForm(v, FloorAssignRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Floor Updated Successfully"
    );

    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getFloorAssignById, setValues);

    return (
        <>
            {(loadingSubmit || loadingFloor || loadingFetch) && <Spinner isSpinner={true} />}
            <EditFloorAssignForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                floorOptions={floorOptions || []}
                setValues={setValues}
            />
        </>
    );
};

export default EditFloorAssign;
